import { WORK_STATUS } from '../lib/remediation'

/** Where an accountant is with one fix — shared by My Ledgers and the admin tracker. */
export default function WorkPill({ status }) {
  const s = WORK_STATUS[status] ?? WORK_STATUS.open
  return (
    <span className={`pill ${s.tone}`}>
      <span className={`d${status === 'in_progress' ? ' rt-pulse' : ''}`} />
      {s.label}
    </span>
  )
}
